module.exports = __webpack_public_path__ + "static/img/add-button-hi.5e11046d.png";